export default __webpack_public_path__ + "static/commercial-lettings-86ee8e0151d0bf1b6882b6bcf99247ba.png";